import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: "Now",
    fontWeight: 700,
    color: "#242A38",
    marginBottom: "0.7em",
  },
  headerSubNote: {
    textAlign: "right",
    color: "rgb(175 179 187)",
    marginBottom: 0,
    fontSize: 10,
    fontWeight: 500,
    [theme.breakpoints.up("sm")]: {
      fontSize: 15,
      fontWeight: 400,
    },
  },
  tabs: {
    padding: 0,
    "& .MuiButtonBase-root": {
      // textTransform: 'none',
      // fontSize: '1.35em',
      // color: '#8F8F8F',
      // padding: '0',
      // marginRight: '2.5em',
      // marginBottom: '0.4em',
      // minWidth: 'auto',
      textTransform: "none",
      fontSize: 12,
      color: "#8F8F8F",
      padding: "0",
      marginRight: theme.spacing(1.5),
      marginBottom: "0.4em",
      minWidth: "auto",
      [theme.breakpoints.up("sm")]: {
        fontSize: 16,
        marginRight: theme.spacing(2),
      },
      [theme.breakpoints.up("lg")]: {
        fontSize: "1.35em",
        marginRight: "2.5em",
      },
    },
    "& .MuiButtonBase-root.Mui-selected": {
      color: "#242A38",
    },
    "& .MuiTabs-indicator": {
      height: "4px",
    },
  },
  tabPanel: {
    "& > .MuiBox-root": {
      margin: theme.spacing(3, 0),
    },
  },
}));
